function calculate_lunar_age(mother_age, birth_month, conception_month) {
    let lunar_age;
    if (birth_month > conception_month) {
        lunar_age = (mother_age + 2);
    } else{
        lunar_age = (mother_age + 1);
    }
    return lunar_age;
}

function calculate_lunar_conception_month(conception_month) {
    let find_conception_month;
    if (conception_month == 1) {
        find_conception_month = 11;
    } else{
        find_conception_month = (conception_month - 1);
    }
    return find_conception_month;
}

$(document).ready(function () {
    let conceptionStartDate = new Date();
    conceptionStartDate.setFullYear(conceptionStartDate.getFullYear() - 1);
    conceptionStartDate.setMonth(1 - 1, 1);
    let conceptionEndDate = new Date();
    conceptionEndDate.setFullYear(conceptionEndDate.getFullYear() + 12);
    conceptionEndDate.setMonth(12 - 1, 31);
    $("#conception_chinese").datepicker({
        showOn: "both",
        buttonText: '<img class="lh-lazy-image lazied" data-src=https://cdn.shopify.com/s/files/1/0428/4973/files/calblue-svg.svg?v=1738043116 alt=calendar_icon width=20 height=20 data-lazied=IMG src=https://cdn.shopify.com/s/files/1/0428/4973/files/calblue-svg.svg?v=1738043116>',
        changeMonth: true,
        changeYear: true,
        yearRange: '-1Y:+12Y',
        defaultDate: new Date(),
        minDate: conceptionStartDate,
        maxDate: conceptionEndDate,
    });
    let dobStartDate = new Date();
    dobStartDate.setFullYear(dobStartDate.getFullYear() - 44);
    dobStartDate.setMonth(1 - 1, 1);
    let dobEndDate = new Date();
    dobEndDate.setFullYear(dobEndDate.getFullYear() - 16);
    dobEndDate.setMonth(12 - 1, 31);
    $("#dob_chinese").datepicker({
        showOn: "both",
        buttonText: '<img class="lh-lazy-image lazied" data-src=https://cdn.shopify.com/s/files/1/0428/4973/files/calblue-svg.svg?v=1738043116 alt=calendar_icon width=20 height=20 data-lazied=IMG src=https://cdn.shopify.com/s/files/1/0428/4973/files/calblue-svg.svg?v=1738043116>',
        changeMonth: true,
        changeYear: true,
        yearRange: '-44Y:-16Y',
        defaultDate: new Date(),
        minDate: dobStartDate,
        maxDate: dobEndDate,
    });

    $("#genderPredictorSubmit").click(function() {
        $('#gend').html('');
        let conceptionObjectDate = new Date($('#conception_chinese').val());
        let conception_month = conceptionObjectDate.getMonth() + 1;

        let motherDobObjectDate = new Date($('#dob_chinese').val());
        let motherDobYear = motherDobObjectDate.getFullYear();
        let birth_month = motherDobObjectDate.getMonth() + 1;
        let motherDobDate = motherDobObjectDate.getDate();
       
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        let currentMonth = currentDate.getMonth() + 1;
        let currentDay = currentDate.getDate();
        var mother_age = currentYear - motherDobYear;
        if (currentMonth < birth_month || (currentMonth === birth_month && currentDay < motherDobDate)) {
          mother_age--;
        }

        let lunar_age = calculate_lunar_age(mother_age, birth_month, conception_month);
        let lunar_conception_month = calculate_lunar_conception_month(conception_month);

        let lunarCalender = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];

        lunarCalender[18] = [1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        lunarCalender[19] = [0, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 1];
        lunarCalender[20] = [1, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0];
        lunarCalender[21] = [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
        lunarCalender[22] = [1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1];
        lunarCalender[23] = [0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1];
        lunarCalender[24] = [0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0];
        lunarCalender[25] = [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0];
        lunarCalender[26] = [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 1];
        lunarCalender[27] = [1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0];
        lunarCalender[28] = [0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1];
        lunarCalender[29] = [1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1];
        lunarCalender[30] = [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0];
        lunarCalender[31] = [0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1];
        lunarCalender[32] = [0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0];
        lunarCalender[33] = [1, 0, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1];
        lunarCalender[34] = [0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1];
        lunarCalender[35] = [0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0];
        lunarCalender[36] = [0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1];
        lunarCalender[37] = [1, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0];
        lunarCalender[38] = [0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1];
        lunarCalender[39] = [1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0];
        lunarCalender[40] = [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0];
        lunarCalender[41] = [1, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1];
        lunarCalender[42] = [0, 1, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0];
        lunarCalender[43] = [1, 0, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0];
        lunarCalender[44] = [0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
        lunarCalender[45] = [1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1];
      
        if (lunar_age < 18 || lunar_age > 45) {
            alert('Chinese gender predictor calculates for ages 18 to 45. Therefore, our tool cannot predict baby\'s gender for your age.');
            return false;
        } else {
            let findGender = lunarCalender[lunar_age][lunar_conception_month];

            if (findGender == 1) {
                $('#type').html('<span style=" color: #d0739c;">It\'s A Baby Girl</span><br/> <picture class="image_converted_webp "><source type=image/avif srcset=https://cdn.shopify.com/s/files/1/0428/4973/files/babygirl.avif?v=1738043354><img src=https://cdn.shopify.com/s/files/1/0428/4973/files/baby-girl.webp?v=1738043397 alt="Baby Girl" title="Baby Girl" /></picture>');
                $('#gend').html('<span style=" color: #d0739c;">a baby girl</span>');
            }
            if (findGender == 0) {
                $('#type').html('<span style=" color: #6290b7;">It\'s A Baby Boy </span><br/> <picture class="image_converted_webp "><source type=image/avif srcset=https://cdn.shopify.com/s/files/1/0428/4973/files/babyboy.avif?v=1738043497><img src=https://cdn.shopify.com/s/files/1/0428/4973/files/babyboy.webp?v=1738043531 alt="Baby Boy" title="Baby Boy" /></picture>');
                $('#gend').html('<span style=" color: #6290b7;">a baby boy</span>');
            }
            $('#result').show();
            $('html,body').animate({
                scrollTop: $("#result").offset().top - 70
            }, 'slow');
        }
    });
    $('.tabs-list h3').click(function() {
        $(this).siblings('.panel').slideToggle(5);
        $(this).siblings('.arrow-down').toggleClass('arrow-up');
    });
    $('.tabs-list .arrow-down').click(function() {
        $(this).siblings('.panel').slideToggle(5);
        $(this).toggleClass('arrow-up');
    });
});